module.exports = __webpack_public_path__ + "static/media/calendar-star.2e6f9a36.svg";